import { EnglishArabicDTO } from "bnsights-control-library"
export class SMSTemplateTesterModel
{
      TemplateID:number
      LangKey :string
      ToMobileNumber :string
      SMSProviderName:string
      KeyMap: any
      ErrorMessage:string
      IsSuccess:boolean


}